

const setStableVH = () => {
    const root = document.documentElement;    
    const vh = window.innerHeight * 0.01;
    const sh = screen.height * 0.01;
    root.style.setProperty('--vh', `${vh}px`);        
    root.style.setProperty('--sh', `${sh}px`);    
}


const setup = () => {
    setStableVH();
}

export { setup };